<template>
  <FieldsIHFailureNoticeModalComponent
    :failure-notice="event"
    :exclude-from-search="excludeFromSearch"
    :flag-types="flagTypes"
  >
    <template #trailing>
      <EventActionFieldRowComponent>
        <FMFileInlineUploadPreview
          v-model:files-ids="event.fileIds"
          :disabled="disableEvent"
          automatic-screenshot
        />
      </EventActionFieldRowComponent>
    </template>
  </FieldsIHFailureNoticeModalComponent>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { FlagTypes } from "@/graphql";
import FieldsIHFailureNoticeModalComponent from "./FieldsIHFailureNoticeModalComponent.vue";
import injectAsserted from "@/functions/assert/injectAsserted";
import { DisableEventInjectionKey } from "@/components/event-action/issue/IssueTypes";
import EventActionFieldRowComponent from "@/components/event-action/EventActionFieldRowComponent.vue";
import FMFileInlineUploadPreview from "@/modules/filemanagement/components/FMFileInlineUploadPreview.vue";
import { type IHFailureNoticeEditType } from "@/components/event-action/event/modal/EventEditType";

defineProps({
  event: {
    type: Object as PropType<IHFailureNoticeEditType>,
    required: true,
  },
  excludeFromSearch: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
});
const disableEvent = injectAsserted(DisableEventInjectionKey);
const flagTypes = computed(() => {
  return [
    FlagTypes.userFlag,
    FlagTypes.mailDistribution,
    FlagTypes.ideaWorld,
    FlagTypes.ihFlag,
    FlagTypes.system,
  ];
});
</script>

<style lang="scss" scoped></style>
